import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const S = {
  page: { minHeight:"100vh", background:"#050510", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif", padding:20 },
  box:  { background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff11", borderRadius:24, padding:40, width:"100%", maxWidth:420 },
  inp:  { width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"13px 16px", color:"#fff", fontSize:15, outline:"none", boxSizing:"border-box", fontFamily:"'DM Sans',sans-serif" },
  btn:  { width:"100%", background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:15, fontWeight:700, fontSize:16, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" },
  lbl:  { display:"block", color:"#9ca3af", fontSize:13, marginBottom:8, textTransform:"uppercase", letterSpacing:1 },
};

export default function Login() {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const navigate = useNavigate();

  const login = async () => {
    if (!email || !password) { setError("Please fill in all fields."); return; }
    setLoading(true); setError("");
    try {
      const res = await API.post("/login", { email, password });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("email", res.data.email);
      window.location.href = "/dashboard";
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed.";
      setError(msg.includes("No account") || msg.includes("Invalid") ? "Wrong email or password. Try again or sign up." : msg);
    }
    setLoading(false);
  };

  return (
    <div style={S.page}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&family=Syne:wght@900&display=swap" rel="stylesheet"/>
      <div style={{ width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:900, color:"#00d4aa", marginBottom:8 }}>⚡ LeadBot Pro</div>
          <p style={{ color:"#6b7280", margin:0 }}>Sign in to your account</p>
        </div>
        <div style={S.box}>
          <div style={{ marginBottom:20 }}>
            <label style={S.lbl}>Email</label>
            <input style={S.inp} type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key==="Enter" && login()} autoFocus/>
          </div>
          <div style={{ marginBottom:24 }}>
            <label style={S.lbl}>Password</label>
            <input style={S.inp} type="password" placeholder="Your password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key==="Enter" && login()}/>
          </div>
          {error && <div style={{ background:"#f8717118", border:"1px solid #f8717144", borderRadius:10, padding:"10px 14px", color:"#f87171", fontSize:13, marginBottom:16 }}>{error}</div>}
          <button style={{ ...S.btn, opacity: loading?0.6:1 }} onClick={login} disabled={loading}>
            {loading ? "Signing in..." : "Sign In →"}
          </button>
          <p style={{ textAlign:"center", marginTop:16, color:"#6b7280", fontSize:14 }}>
            <span onClick={() => navigate("/forgot-password")} style={{ color:"#00d4aa", cursor:"pointer" }}>Forgot password?</span>
          </p>
          <p style={{ textAlign:"center", marginTop:8, color:"#6b7280", fontSize:14 }}>
            No account? <span onClick={() => navigate("/signup")} style={{ color:"#00d4aa", cursor:"pointer", fontWeight:700 }}>Sign up free</span>
          </p>
        </div>
        <p onClick={() => navigate("/")} style={{ textAlign:"center", marginTop:20, color:"#4b5563", fontSize:13, cursor:"pointer" }}>← Back to home</p>
      </div>
    </div>
  );
}
